import React, { Component } from 'react'
import {
  Grid,
  Table,
  TableHeaderRow,
  TableColumnReordering,
  TableRowDetail,
  TableSelection,
  TableFilterRow
} from '@devexpress/dx-react-grid-bootstrap4'
import {
  RowDetailState,
  IntegratedSelection,
  SelectionState,
  IntegratedFiltering,
  FilteringState
} from '@devexpress/dx-react-grid'
import { Tooltip } from '@material-ui/core'
import { saveAs } from 'file-saver'
import { debounce } from '../../../helpers/debounce'
import * as actions from '../actions/index'
import { connect } from 'react-redux'
import DescargaPdf from '../../PdfDownload/container/DescargaPdf'

class GrillaCeaPendienteAutoriz extends Component {
  constructor (props) {
    super(props)
    this.state = { expandedRowIds: [] }
    this.customTitleMap = {
      cartaDePorteAutomotor: 'Carta de porte',
      fechaCalado: 'Fecha de calado',
      perito: 'Perito',
      camion: 'Camión',
      cereal: 'Cereal',
      exportador: 'Exportador',
      titulaDeCupo: 'Titular',
      calificacionCereal: 'Calificación',
      puesto: 'Puesto',
      turnoDeSalida: 'Turno de salida',
      calleDeCalado: 'Calle',
      humedad: 'Humedad',
      vendedor: 'Representante',
      variedad: 'Variedad',
      remitenteComercial: 'Remitente comercial',
      corredorComprador: 'Corredor',
      ctg: ' '
    }

    this.parseColumnSet = this.parseColumnSet.bind(this)
    this.parseColumnExtensions = this.parseColumnExtensions.bind(this)
    this.getTitle = this.getTitle.bind(this)

    this.columnsToShow = ['cartaDePorteAutomotor', 'fechaCalado', 'camion', 'cereal',
      'variedad', 'exportador', 'titulaDeCupo', 'remitenteComercial',
      'calificacionCereal', 'humedad', 'ctg']
    this.columnsToExpand = ['corredorComprador', 'perito', 'vendedor',
      'turnoDeSalida', 'puesto', 'calleDeCalado']
    this.onlyColumns = [...this.columnsToShow, ...this.columnsToExpand]

    this.changeExpandedDetails = (newExpandedRowIds) => {
      const { expandedRowIds } = this.state
      const sumNew = newExpandedRowIds.reduce((a, c) => a + c, 0)
      const sum = expandedRowIds.reduce((a, c) => a + c, 0)
      const newCandidates = (sumNew === 0 && newExpandedRowIds.length === 0)
        ? [] : [Math.abs(sumNew - sum)]
      this.setState({ expandedRowIds: newCandidates })
    }
    this.handleSelectionChange = debounce(
      this.handleSelectionChange.bind(this), 300)
  }

  handleSelectionChange (selections) {
    const selectedRows = []
    selections && selections.forEach(
      s => selectedRows.push(this.props.rows[s]), this)
    this.props.onSelectionChange && this.props.onSelectionChange(selectedRows)
  }

  getTitle (column) {
    return this.customTitleMap[column]
      ? this.customTitleMap[column] : column
  }

  savePdf (url, filename) {
    this.props.saveDetallePdf()
    saveAs(url, filename)
  }

  parseColumnSet (row, only = this.columnsToShow) {
    if (!row) return []
    return Object.keys(row)
      .filter(c => !only ? true : only.includes(c))
      .map(c => {
        if (c === 'ctg') {
          return {
            name: c,
            title: ' ',
            getCellValue: (rowData) => (
              <Tooltip title={'Descargar PDF desde ARCA'}>
                <DescargaPdf url={`${process.env.REACT_APP_PDF_URL}${rowData[c]}.pdf`} filename={rowData[c]} />
              </Tooltip>
            )
          }
        } else {
          return { name: c, title: (this.getTitle(c)) }
        }
      }, this)
  }

  parseColumnExtensions (row, only = this.columnsToShow) {
    if (!row) return []
    return Object.keys(row)
      .filter(c => !only ? true : only.includes(c))
      .map(c => ({ columnName: c, align: 'center' }), this)
  }

  getTableComponent () {
    return ({ ...restProps }) => (
      <Table.Table
        {...restProps}
        className='table-striped'
      />)
  }

  getRowDetail () {
    return ({ row }) => {
      return this.columnsToExpand.map(c => (
        <p> { this.getTitle(c)}:  <b>{row[c]}</b>  </p>
      ))
    }
  }

  render () {
    const { rows } = this.props
    const { expandedRowIds, selection } = this.state
    const row = rows[0]

    return (
      <div className='grilla-cea-pendiente-autoriz'>
        <Grid
          showBorders
          rows={rows}
          keyExpr={'cartaDePorteAutomotor'}
          columns={this.parseColumnSet(row)}>
          <SelectionState
            selection={selection}
            onSelectionChange={this.handleSelectionChange}
          />
          <RowDetailState
            expandedRowIds={expandedRowIds}
            onExpandedRowIdsChange={this.changeExpandedDetails}
          />
          <FilteringState defaultFilters={[]} />
          <IntegratedFiltering />
          <Table
            tableComponent={this.getTableComponent()}
            columnExtensions={this.parseColumnExtensions(row)} />
          <TableFilterRow />
          <TableHeaderRow />
          <TableColumnReordering order={this.columnsToShow} />
          <TableRowDetail contentComponent={this.getRowDetail()} />
          <IntegratedSelection />
          <TableSelection selectByRowClick highlightRow showSelectAll />
        </Grid>
      </div>
    )
    /*
    <VirtualTable tableComponent={this.getTableComponent()} />
    */
  }
}

const withRedux = connect(null, actions)
export default withRedux(GrillaCeaPendienteAutoriz)
